import { render, staticRenderFns } from "./SlackHistoryModal.vue?vue&type=template&id=b81abbea"
import script from "./SlackHistoryModal.vue?vue&type=script&lang=js"
export * from "./SlackHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports